// Sections moved from apps/backoffice (Workflow Studio, Integrations, AI Governance, Audit & Security).
export default {
  governance: {
    agentCatalog: {
      tab: "الوكلاء",
      hint: "كل مكون ذكاء اصطناعي في المنصة: الغرض منه، وما يقرأه وينتجه، والأدوات الحتمية التي يمكنه استدعاؤها، وخطوات الإجراء التي تستدعيه، ومن يعتمد مقترحاته، وأي ضوابط تنطبق عليه. صدر الفهرس بصيغة Markdown لوثائق العميل.",
      filter: "تصفية الوكلاء…",
      count: "{{count}} وكيل", count_zero: "لا وكلاء", count_one: "وكيل واحد", count_two: "وكيلان", count_few: "{{count}} وكلاء", count_many: "{{count}} وكيلا", count_other: "{{count}} وكيل",
      export: "تصدير Markdown",
      categories: {
        WorkflowAgent: "وكلاء الإجراءات",
        Assistant: "المساعدون",
        Service: "خدمات المعالجة"
      },
      deterministic: "حتمي / معالجة",
      accepted: "مقبول",
      inputs: "يقرأ",
      outputs: "ينتج",
      runsAt: "يعمل في",
      tools: "الأدوات",
      humanDecision: "القرار البشري",
      guardrails: "الضوابط",
      last30: "آخر 30 يوما: {{runs}} تشغيل، {{proposals}} مقترح"
    },
    modelManaged: "تدار من قبل المنصة؛ يضبط المزود الأساسي في البوابة الآمنة.",
    title: "حوكمة الذكاء الاصطناعي",
    subtitle: "توجيه النماذج وضوابط الأمان والتقييمات والانحراف وسجل المخاطر وفحص التكافؤ بين العربية والإنجليزية لكل وظيفة ذكاء اصطناعي.",
    routing: "توجيه النماذج",
    guardrails: "ضوابط الأمان",
    evals: "التقييمات",
    drift: "الانحراف",
    pii: "إخفاء البيانات الشخصية",
    prompts: "نسخ التعليمات",
    feedback: "التغذية الراجعة البشرية",
    overview: "نظرة عامة",
    runs: "تشغيلات الوكلاء",
    runsFooter: "{{failed}} فاشلة · {{cases}} حالة بمساعدة الذكاء الاصطناعي",
    quality: "جودة الذكاء الاصطناعي",
    qualityFooter: "مراجعة الجودة الآلية {{score}}/100 – المقترحات المشمولة: {{count}}",
    revisionRuns: "المراجعات بطلب من المراجعين: {{count}}",
    tokens: "الرموز: {{count}}",
    tokensShort: "الرموز",
    tokensFooter: "{{input}} مدخلات · {{output}} مخرجات",
    acceptance: "نسبة القبول",
    acceptanceFooter: "{{edited}}% عدلت قبل الموافقة · {{pending}} معلقة",
    confidence: "متوسط الثقة",
    confidenceFooter: "متوسط التشغيل {{ms}} مللي ثانية",
    blockedFooter: "المخرجات المحجوبة: {{count}}",
    piiFooter: "{{tools}} استدعاء أدوات · {{retrievals}} استرجاع",
    offlineTitle: "الوضع الحتمي دون اتصال",
    offlineHint: "بوابة الذكاء الاصطناعي غير متصلة، لذا تعمل الوكلاء بمسوداتها القاعدية. الثقة محدودة بـ45% حتى تفعيل البوابة.",
    activity14d: "النشاط – آخر 14 يوما",
    activityHint: "التشغيلات والمقترحات ونتائج ضوابط الأمان يوميا.",
    guardrailsByRule: "نتائج ضوابط الأمان حسب القاعدة",
    guardrailsByRuleHint: "تسجل كل نتيجة مع التشغيل الذي أنتجها.",
    events: "حدثا",
    byAgent: "التشغيلات والنتائج حسب الوكيل",
    byAgentHint: "أكثر الوكلاء نشاطا.",
    usagePerCase: "استخدام النماذج لكل حالة",
    usagePerCaseHint: "الحالات الأكثر استخداما للنماذج؛ النقر على حالة يفتح تبويب الوكلاء.",
    agentTable: "بطاقة أداء الوكلاء",
    agent: "الوكيل",
    model: "النموذج",
    proposals: "المقترحات",
    latency: "زمن الاستجابة",
    tiers: {
      Reasoning: "استدلال",
      Fast: "سريع",
      Vision: "رؤية",
      Embedding: "تضمين",
      Stt: "تحويل الكلام إلى نص"
    },
    configured: "المضبوط",
    overrides: "يتجاوز",
    configuredDefault: "الافتراضي المضبوط",
    routeTable: "مسارات النماذج",
    routeTableHint: "مسار نشط واحد لكل فئة؛ ويتجاوز المسار النشط الافتراضي المضبوط أثناء التشغيل.",
    tier: "الفئة",
    fallback: "البديل",
    context: "السياق",
    out: "مخرجات",
    usage: "الاستخدام",
    active: "نشط",
    inactive: "غير نشط",
    effective: "مستخدم",
    adminOnly: "يمكن لمسؤول المنصة فقط تغيير المسارات.",
    editRoute: "تعديل مسار {{tier}}",
    editRouteHint: "تسري التغييرات فورا على التشغيلات الجديدة وتسجل في سجل التدقيق.",
    notes: "ملاحظات",
    activeForTier: "المسار النشط لهذه الفئة",
    routeSaved: "تم تحديث مسار النموذج",
    routeRelease: {
      hint: "تغيير النموذج تحديث بمقتضى الشرطين 1.5 و3.7: يضاف إلى مسودة إصدارك ولا يسري إلا بعد أن يعتمده مسؤول ثان في صفحة الإصدارات.",
      staged: "أضيف إلى مسودة إصدارك",
      stagedBody: "\"{{title}}\": يقدم من صفحة الإصدارات، ويتغير المسار بعد أن يعتمده مسؤول ثان.",
      pending: "تغيير بانتظار الإصدار",
    },
    guardrailEvents: "أحداث ضوابط الأمان",
    guardrailEventsHint: "نتائج فاحص المخرجات: لغة القرار، تسرب البيانات الشخصية، استشهادات مفقودة أو غير معروفة، أرقام ليست من الأدوات، حقن التعليمات.",
    allRules: "كل القواعد",
    allSeverities: "كل الدرجات",
    rule: "القاعدة",
    detail: "التفصيل",
    action: "الإجراء",
    rules: {
      PromptInjection: "حقن التعليمات",
      DecisionLanguage: "لغة القرار",
      PiiLeak: "تسرب بيانات شخصية",
      MissingCitations: "استشهادات مفقودة",
      UnknownCitation: "استشهاد غير معروف",
      NumberNotFromTool: "رقم ليس من أداة",
      LanguageMismatch: "عدم تطابق اللغة",
      ArabicParity: "النص العربي يختلف عن الإنجليزي",
      FigureCheck: "تدقيق الأرقام",
      ConfidenceLanguage: "دون درجة احتمال أو ثقة",
      SchemaViolation: "مخالفة المخطط"
    },
    severities: {
      Info: "معلومة",
      Warning: "تحذير",
      Blocked: "محجوب"
    },
    noPrompts: "لم تسجل نسخ تعليمات بعد",
    noPromptsHint: "تلتقط التعليمات من تشغيلات الوكلاء الفعلية – شغل أي وكيل لتسجيل نسخته الحالية.",
    versionCount: "عدد النسخ: {{count}}",
    chars: "حرفا",
    runsWithVersion: "{{count}} تشغيل", runsWithVersion_zero: "لا تشغيلات", runsWithVersion_one: "تشغيل واحد", runsWithVersion_two: "تشغيلان", runsWithVersion_few: "{{count}} تشغيلات", runsWithVersion_many: "{{count}} تشغيلا", runsWithVersion_other: "{{count}} تشغيل",
    firstSeen: "أول ظهور",
    cacheHit: "{{rate}}% من المدخلات قرئت من ذاكرة التخزين المؤقت للمطالبات",
    evalsHint: "مجموعات ذهبية للأدوات الحتمية وإخفاء البيانات الشخصية ودقة الاسترجاع وتسجيلات النماذج المحفوظة تعمل دون اتصال؛ أما مجموعة الإجابات الحية فتستدعي النموذج المهيأ من البداية إلى النهاية.",
    overallAccuracy: "الدقة الإجمالية {{percent}}%",
    runAll: "تشغيل كل التقييمات",
    goldenCases: "{{count}} حالة ذهبية", goldenCases_zero: "لا حالات ذهبية", goldenCases_one: "حالة ذهبية واحدة", goldenCases_two: "حالتان ذهبيتان", goldenCases_few: "{{count}} حالات ذهبية", goldenCases_many: "{{count}} حالة ذهبية", goldenCases_other: "{{count}} حالة ذهبية",
    cassettes: "إعادة تشغيل التسجيلات",
    neverRun: "لم يشغل",
    driftAlert: "انحراف",
    accuracy: "الدقة",
    faithfulness: "أمانة الاستشهاد",
    schemaValidity: "صلاحية المخطط",
    historyHint: "التشغيلات في السجل: {{count}}",
    passed: "ناجحة",
    expected: "المتوقع",
    actual: "الفعلي",
    evalDone: "المجموعات المقيمة: {{count}} – الدقة {{accuracy}}%",
    driftAlerts: "الوكلاء المنحرفون: {{count}}",
    driftAlertsHint: "انخفضت الثقة 10 نقاط أو ارتفعت نسبة الرفض 15 نقطة مقارنة بخط الأساس.",
    noDrift: "لم يرصد انحراف",
    noDriftHint: "الثقة ونسب الرفض خلال آخر {{days}} يوما ضمن حدود خط الأساس.",
    driftTable: "انحراف الوكلاء",
    driftTableHint: "النافذة الحالية ({{days}} يوما) مقابل ما قبلها؛ اتجاه الثقة الأسبوعي على اليسار.",
    rejectionRate: "نسبة الرفض",
    weeklyConfidence: "الثقة الأسبوعية",
    stable: "مستقر",
    evalDrift: "تنبيهات انحراف التقييم",
    piiTokens: "رموز البيانات الشخصية",
    piiCases: "عبر حالات عددها {{count}}",
    docsRedacted: "مستندات منقحة",
    leaksCaught: "تسريبات محجوبة",
    leaksHint: "بيانات شخصية خام رصدت في مخرجات النموذج",
    injections: "محاولات حقن مرصودة",
    injectionsHint: "تعليمات وجدت داخل المستندات",
    categories: "الفئات",
    byCategory: "الرموز حسب الفئة",
    byCategoryHint: "تستبدل بأسماء مستعارة قبل خروج أي نص من المنصة.",
    piiCategories: {
      EmiratesId: "الهوية الإماراتية",
      Person: "شخص",
      Phone: "هاتف",
      Email: "بريد إلكتروني",
      Iban: "IBAN",
      Passport: "جواز سفر",
      Address: "عنوان"
    },
    piiByAgent: "الإخفاء حسب الوكيل",
    piiByAgentHint: "الوكلاء الذين تطلبت مدخلاتهم إخفاء البيانات.",
    risks: {
      tab: "سجل المخاطر",
      hint: "كل وظيفة من وظائف الذكاء الاصطناعي، والمخاطر التي تنطوي عليها، والضمانة التي تعالج كلا منها. يراجع المدير أو مسؤول المنصة كل قيد: الوظائف عالية المخاطر كل ستة أشهر، والبقية كل سنة. وتجمع وثائق النماذج ذلك مع التعليمات والاختبارات والاستخدام لكل وظيفة.",
      due: "مستحقة المراجعة: {{count}}",
      allReviewed: "روجعت جميع القيود",
      allLevels: "جميع المستويات",
      download: "تنزيل وثائق النماذج",
      levels: {
        Minimal: "مخاطر ضئيلة",
        Limited: "مخاطر محدودة",
        High: "مخاطر عالية"
      },
      level: "مستوى المخاطر",
      residual: "المخاطر المتبقية",
      residualIs: "المتبقي: {{level}}",
      owner: "يعتمد المسودات: {{role}}",
      notReviewed: "لم يراجع بعد",
      reviewedBy: "روجع في {{date}} من قبل {{name}}",
      nextReview: "المراجعة التالية {{date}}",
      overdue: "المراجعة مستحقة",
      usage: "آخر 30 يوما: عمليات التشغيل {{runs}}، أحداث الضمانات {{events}}، المحجوب {{blocked}}",
      actionsRequired: "الإجراءات المطلوبة",
      showRisks: "المخاطر والضمانات ({{count}})",
      record: "تسجيل المراجعة",
      recordTitle: "مراجعة: {{name}}",
      recordHint: "سجل ما فحصته وما خلصت إليه. يحدد موعد المراجعة التالية وفق المستوى الذي تؤكده.",
      registerSays: "يقترح السجل: {{level}}",
      notes: "ما روجع وما خلصت إليه المراجعة",
      notesHint: "20 حرفا على الأقل.",
      actions: "الإجراءات التي ستخفض المخاطر",
      actionsHint: "مطلوبة عندما تبقى مخاطر عالية.",
      nextHigh: "تستحق المراجعة التالية بعد ستة أشهر.",
      nextOther: "تستحق المراجعة التالية بعد سنة.",
      saved: "سجلت المراجعة",
      reviewerOnly: "يسجل المدير أو مسؤول المنصة المراجعات."
    },
    parity: {
      tab: "العربية والإنجليزية",
      hint: "كل {{days}} يوما تقرأ المنصة مسودات الذكاء الاصطناعي للربع الأخير وتتحقق من أن كل وظيفة تخدم العربية كما تخدم الإنجليزية: ألا يكون النص العربي أقصر كثيرا من الإنجليزي، وأن يورد الأرقام نفسها، وألا يرفض المراجعون مسودات الملفات العربية أكثر مما تفسره الصدفة، وأن تأتي مسودات الملفات العربية بالعربية. ولا يحكم على أي مقياس إلا بعد {{min}} مسودات أو أكثر.",
      notRun: "لم يجر الفحص بعد",
      notRunHint: "شغل الفحص لقياس مسودات آخر {{days}} يوما.",
      passed: "لا ملاحظات في الفحص الأخير",
      failed: "ملاحظات الفحص الأخير: {{count}}",
      summary: "فحص في {{date}} من قبل {{by}}، وعدد المسودات المقروءة {{count}}. يستحق الفحص التالي في {{next}}.",
      due: "الفحص مستحق",
      run: "شغل الفحص الآن",
      ran: "اكتمل فحص التكافؤ اللغوي",
      runnerOnly: "يشغل المدير أو مسؤول المنصة الفحص، ويجري تلقائيا أيضا عند استحقاقه.",
      table: "حسب وظيفة الذكاء الاصطناعي",
      window: "المسودات من {{from}} إلى {{to}}.",
      thresholds: "تسجل ملاحظة إذا: كان النص العربي أقل من {{coverage}}× طول الإنجليزي؛ أو حفظت الأرقام في أقل من {{figures}}٪ من المسودات؛ أو تجاوز فرق الرفض {{gap}} نقطة ولم تفسره الصدفة؛ أو غابت العربية عن أكثر من {{missing}}٪ من مسودات الملفات العربية.",
      noDrafts: "لا توجد مسودات ذكاء اصطناعي في الفترة",
      agent: "وظيفة الذكاء الاصطناعي",
      drafts: "المسودات",
      bilingual: "باللغتين: {{count}}",
      coverage: "طول العربية",
      figures: "الأرقام المحفوظة",
      rejected: "المرفوض: ملفات عربية / إنجليزية",
      missing: "ملفات عربية بلا عربية",
      findingsColumn: "الملاحظات",
      none: "لا ملاحظات",
      findings: {
        coverage: "العربية أقصر كثيرا",
        figures: "أرقام غائبة عن العربية",
        review: "رفض أكثر لمسودات الملفات العربية",
        "missing-arabic": "غياب العربية عن الملفات العربية"
      },
      history: "الفحوص السابقة",
      draftsRead: "المسودات المقروءة: {{count}}",
      findingCount: "الملاحظات: {{count}}"
    },
    adoption: {
      tab: "كيف تؤخذ المسودات",
      hint: "هل يقرر الموظفون أم يتبنون: لكل وظيفة ذكاء اصطناعي ولكل موظف، كم مسودة اعتمدت دون تغيير أو عدلت أو رفضت، وهل الأسباب المذكورة أسبابهم. ولا تعتمد مسودات الوظائف عالية المخاطر إلا بأسباب الموظف نفسه ({{min}} حرفا على الأقل، غير منقولة من المسودة). وتستبعد ملفات الاختبار.",
      window: "الفترة",
      days: "آخر {{count}} يوم",
      days_one: "آخر يوم",
      days_two: "آخر يومين",
      days_few: "آخر {{count}} أيام",
      days_many: "آخر {{count}} يوما",
      days_other: "آخر {{count}} يوم",
      reviewed: "روجعت {{count}} مسودة من {{from}} إلى {{to}}.",
      reviewed_zero: "لم تراجع أي مسودة من {{from}} إلى {{to}}.",
      reviewed_one: "روجعت مسودة واحدة من {{from}} إلى {{to}}.",
      reviewed_two: "روجعت مسودتان من {{from}} إلى {{to}}.",
      reviewed_few: "روجعت {{count}} مسودات من {{from}} إلى {{to}}.",
      reviewed_many: "روجعت {{count}} مسودة من {{from}} إلى {{to}}.",
      reviewed_other: "روجعت {{count}} مسودة من {{from}} إلى {{to}}.",
      thresholds: "ينظر في الأمر عند: اعتماد {{rate}}% أو أكثر دون تغيير في {{reviews}} مراجعة أو أكثر؛ أو تكرار الموظف الأسباب نفسها {{repeated}} مرات أو أكثر.",
      functions: "حسب وظيفة الذكاء الاصطناعي",
      officers: "حسب الموظف",
      function: "الوظيفة",
      officer: "الموظف",
      level: "المخاطر",
      reviewedColumn: "روجعت",
      unchanged: "دون تغيير",
      edited: "عدلت",
      rejected: "رفضت",
      medianEdit: "وسيط التعديل",
      repeated: "أسباب مكررة",
      findingsColumn: "ما ينظر فيه",
      none: "لا شيء",
      noReviews: "لا مسودات مراجعة في الفترة",
      forbidden: "يطلع المدير أو المسؤول على كيفية أخذ الموظفين لمسودات الذكاء الاصطناعي.",
      findings: {
        unchanged: "اعتماد شبه كامل دون تغيير",
        "repeated-reasons": "تكرار الأسباب نفسها"
      }
    }
  },
  workflowStudio: {
    title: "استوديو الإجراءات",
    subtitle: "تعريفات إجراءات مرقمة ومتوافقة مع التشريعات. تسري التغييرات على الحالات الجديدة فقط.",
    definitions: "التعريفات",
    templates: "قوالب المراسلات",
    holidays: "تقويم العطلات",
    fees: "جدول الرسوم",
    thresholds: "الحدود",
    advisor: "مستشار التغيير",
    newVersion: "إنشاء نسخة جديدة",
    pendingAdvice: "مراجعات الإجراءات بانتظار المسؤول: {{count}}",
    active: "نشطة",
    draft: "مسودة",
    states: "حالة",
    transitions: "انتقالا",
    clocks: "مددا قانونية",
    agentHooks: "ارتباطات وكلاء",
    editDraft: "تعديل المسودة",
    kind: "النوع",
    actors: "الأدوار المسؤولة",
    forms: "النماذج",
    legalBasis: "الأساس القانوني",
    applicantSees: "ما يراه مقدم الطلب",
    hidden: "مخفية",
    onExpiry: "عند الانتهاء",
    wd: "يوم عمل",
    d: "يوما",
    version: "النسخة",
    changeNote: "ملاحظة التغيير",
    changeNoteHint: "سبب هذه النسخة – تصبح سجل التدقيق ونقطة انطلاق مستشار التغيير.",
    selectHint: "تعرض أدوار الخطوة ونماذجها ومددها القانونية وارتباطات الوكلاء عند اختيارها.",
    activationAdminOnly: "يمر التفعيل عبر الإصدارات: تضاف المسودة إلى إصدار، يراجعها المستشار ويعتمدها مسؤول ثان. يمكن لأي موظف إعداد مسودة وطلب مراجعة.",
    stagedHint: "أدرجت المسودة v{{version}} في الإصدار. قدم الإصدار للاعتماد لتفعيلها للحالات الجديدة.",
    editingDraft: "تعديل المسودة {{version}}",
    newVersionFrom: "نسخة جديدة بناء على النسخة {{version}}",
    unsaved: "تغييرات غير محفوظة",
    adviceReady: "مراجعة المستشار جاهزة",
    validate: "تحقق",
    valid: "المخطط صالح.",
    invalid: "الأخطاء الواجب إصلاحها قبل تفعيل هذه النسخة: {{count}}.",
    saveDraft: "حفظ كمسودة نسخة",
    draftSaved: "تم حفظ المسودة {{version}} – تحتفظ الحالات الجارية بنسختها الحالية.",
    saveFailed: "لم يمكن حفظ المسودة",
    askAdvisor: "طلب مستشار التغيير",
    advisorQueued: "مستشار تغيير الإجراءات يراجع المسودة؛ سيظهر تقييمه في صندوق الذكاء الاصطناعي.",
    deleteDraft: "حذف المسودة",
    draftDeleted: "تم حذف المسودة",
    activate: "تفعيل للحالات الجديدة",
    activated: "النسخة {{version}} نشطة الآن للحالات الجديدة.",
    addState: "إضافة حالة",
    newState: "حالة جديدة",
    newClock: "مدة جديدة",
    validation: "التحقق",
    noIssues: "لا توجد ملاحظات تحقق.",
    diffTitle: "التغييرات مقابل النسخة النشطة {{version}}",
    changes: "تغييرا",
    runningCases: "الحالات الجارية على النسخة النشطة: {{count}}",
    noDiff: "لا فرق عن النسخة النشطة بعد.",
    openAdvice: "فتح مراجعة المستشار في صندوق الذكاء الاصطناعي",
    selectState: "اختيار حالة للتعديل",
    editorHint: "النقر على حالة في المخطط يتيح تعديل تسمياتها وأدوارها ومددها القانونية وارتباطات الوكلاء وانتقالاتها. ويدرج زر «إضافة حالة» خطوة جديدة.",
    key: "المفتاح",
    caseStatus: "حالة الطلب",
    laneOrder: "المسار · الترتيب",
    visibleToApplicant: "ظاهرة لمقدم الطلب",
    publicLabel: "التسمية العامة",
    addClock: "إضافة مدة",
    workingDays: "أيام عمل",
    extension: "أقصى تمديد (أيام)",
    primary: "أساسية",
    noExpiryTrigger: "لا إجراء عند الانتهاء",
    dueFromField: "الاستحقاق في تاريخ مسجل (مفتاح حقل النموذج، مثل nextHearing)",
    dueFromFieldHint: "أحدث قيمة مسجلة في مهمة مكتملة، وإلا في نموذج الطلب، تحدد تاريخ الاستحقاق؛ ويتم تجاهل عدد الأيام أعلاه.",
    outgoing: "الانتقالات الصادرة",
    addTransition: "إضافة انتقال",
    automatic: "آلي",
    guard: "شرط (مثال fee.paid)",
    rolesAndClocks: "الأدوار والمدد",
    completesClocks: "ينهي المدد",
    pausesClocks: "يوقف المدد",
    resumesClocks: "يستأنف المدد",
    notes: "ملاحظات",
    removeState: "إزالة الحالة",
    templatesHint: "قوالب مراسلات ثنائية اللغة يستخدمها وكيل المراسلات. تملأ المتغيرات من الحالة عند الإرسال. ويصبح كل تعديل، في الصياغة أو في مدة الرد المذكورة، النسخة التالية من القالب في مسودة إصدارك، ولا يسري إلا بعد أن يعتمد الإصدار مسؤول ثان.",
    commonTemplates: "قوالب مشتركة",
    sentCount: "مرات الإرسال: {{count}}",
    placeholders: "المتغيرات",
    previewWithCase: "معاينة بحالة فعلية",
    editTemplate: "تعديل القالب",
    editTemplateHint: "حافظ على توافق النسختين العربية والإنجليزية؛ ويعتد بالنص العربي الرسمي.",
    responseDays: "مدة الرد (أيام)",
    templateSaved: "تم حفظ القالب كنسخة جديدة",
    holidaysHint: "العطلات الاتحادية التي تتخطاها كل مدة بأيام العمل؛ تحدث ذاكرة التقويم فورا.",
    addHoliday: "إضافة عطلة",
    addHolidayHint: "إضافة عطلة لاحقا تنقل كل موعد محسوب بأيام العمل لا يزال جاريا عبرها، ويبلغ الموظف المختص والطرف المعني بذلك.",
    holidayMoved: "المواعيد الجارية التي نقلت: {{moved}}، في عدد من الملفات: {{cases}}.",
    configStaged: "أضيف إلى مسودة إصدارك",
    configStagedHint: "«{{title}}» – يسري بعد أن يعتمد الإصدار مسؤول ثان.",
    openRelease: "فتح الإصدار",
    awaitingRelease: "بانتظار الإصدار: {{title}}",
    date: "التاريخ",
    holidayAdded: "تمت إضافة العطلة",
    feesHint: "الرسوم التي يحتسبها محاكي الدفع ويعرضها مساعد الإيداع (قرار مجلس الوزراء رقم 105 لسنة 2026). ولا يسري أي تغيير إلا بإصدار يعتمده مسؤول ثان.",
    refundable: "قابل للرد",
    cap: "بحد أقصى {{amount}} درهم",
    effectiveFrom: "ساري من",
    editFee: "تعديل الرسم",
    editFeeHint: "تعبر الرسوم النسبية كمعدل (0.0002 = 0.02%).",
    fixedAmount: "مبلغ ثابت (درهم)",
    percentRate: "المعدل",
    capAmount: "الحد الأقصى (درهم)",
    feeSaved: "تم تحديث جدول الرسوم",
    thresholdsHint: "الحدود الرقمية التي تستخدمها الحاسبات الحتمية (قرار مجلس الوزراء رقم 3 لسنة 2025 ونطاقات HHI للوزارة).",
    editThreshold: "تعديل الحد",
    editThresholdHint: "تسري التغييرات على التقييمات الجديدة وتسجل في سجل التدقيق.",
    value: "القيمة",
    unit: "الوحدة",
    thresholdSaved: "تم تحديث الحد",
    advisorHint: "يراجع مستشار تغيير الإجراءات كل مسودة: المدد القانونية، تغطية الأدوار، ارتباطات الوكلاء، التغييرات الظاهرة لمقدمي الطلبات، وأثر التطبيق. تفعل الموافقة على مقترحه النسخة.",
    noAdvice: "لا مراجعات إجراءات بعد",
    noAdviceHint: "أعد نسخة جديدة في تبويب التعريفات واطلب مراجعة مستشار التغيير."
  },
  audit: {
    title: "التدقيق والأمن",
    subtitle: "سلسلة تدقيق مقاومة للتلاعب وبث SIEM ومصفوفة الأدوار.",
    chainValid: "تم التحقق من سلسلة التجزئة",
    chainBroken: "سلسلة التجزئة مكسورة",
    chainBrokenHint: "{{tampered}} حدث بتجزئة غير متطابقة و{{links}} رابط مكسور؛ أول مشكلة عند التسلسل {{first}}.",
    verify: "التحقق من السلسلة",
    siem: "بث SIEM",
    siemHint: "حدثا مرسلا",
    rbac: "مصفوفة الأدوار",
    securityPosture: "الوضع الأمني",
    explorer: "المستكشف",
    events: "أحداث التدقيق",
    last24h: "خلال آخر 24 ساعة: {{count}}",
    last24hPlain: "آخر 24 ساعة",
    securityEvents: "الأحداث الأمنية",
    warningsCount: "{{count}} تحذير", warningsCount_zero: "لا تحذيرات", warningsCount_one: "تحذير واحد", warningsCount_two: "تحذيران", warningsCount_few: "{{count}} تحذيرات", warningsCount_many: "{{count}} تحذيرا", warningsCount_other: "{{count}} تحذير",
    logins: "عمليات الدخول",
    headSequence: "رأس السلسلة",
    verifyToSee: "تحقق لعرض تجزئة الرأس",
    activity14d: "الأحداث – آخر 14 يوما",
    searchPlaceholder: "البحث في الإجراء أو الفاعل أو الكيان…",
    allActions: "كل الإجراءات",
    allSeverities: "كل الدرجات",
    allActors: "كل الفاعلين",
    pageChainOk: "الروابط في هذه الصفحة سليمة",
    pageChainBroken: "رابط مكسور في هذه الصفحة",
    actor: "الفاعل",
    action: "الإجراء",
    entity: "الكيان",
    severity: "الدرجة",
    chain: "السلسلة",
    before: "قبل",
    after: "بعد",
    severities: {
      Info: "معلومة",
      Warning: "تحذير",
      Security: "أمني"
    },
    actorKinds: {
      Human: "بشري",
      System: "النظام",
      Agent: "وكيل ذكاء اصطناعي"
    },
    siemStream: "بث SIEM",
    siemStreamHint: "الأحداث الأمنية والتحذيرية المرسلة إلى محاكي SIEM، الأحدث أولا.",
    live: "مباشر",
    platformCapabilities: "صلاحيات المنصة",
    platformCapabilitiesHint: "سياسات التفويض التي تفرضها الواجهة البرمجية حسب دور الموظف.",
    capability: "الصلاحية",
    policy: "السياسة",
    roleShort: {
      EconomicResearcher: "باحث اقتصادي",
      LegalResearcher: "باحث قانوني",
      EconomicExpert: "خبير اقتصادي",
      LegalExpert: "خبير قانوني",
      HeadOfComplaints: "رئيس الشكاوى",
      Director: "المدير",
      AssistantUndersecretary: "الوكيل المساعد",
      Undersecretary: "وكيل الوزارة",
      Minister: "الوزير",
      JudicialOfficer: "مأمور ضبط",
      CommitteeMember: "اللجنة",
      Admin: "المسؤول"
    },
    statesCount: "{{count}} حالة", statesCount_zero: "لا حالات", statesCount_one: "حالة واحدة", statesCount_two: "حالتان", statesCount_few: "{{count}} حالات", statesCount_many: "{{count}} حالة", statesCount_other: "{{count}} حالة",
    state: "الحالة",
    actors: "الفاعلون",
    agents: "الوكلاء",
    system: "النظام",
    personas: "الشخصيات التجريبية",
    logins7d: "عمليات الدخول (7 أيام)",
    loginsFooter: "{{staff}} موظفون · {{uaePass}} الهوية الرقمية",
    promptInjections: "محاولات حقن التعليمات",
    promptInjectionsHint: "أنماط تعليمات وجدت في المستندات",
    piiLeaks: "تسريبات بيانات محجوبة",
    piiLeaksHint: "معرفات خام أوقفت في مخرجات النموذج",
    protectedContacts: "هويات محمية",
    protectedContactsHint: "بيانات اتصال المبلغين مشفرة عند التخزين",
    controls: "الضوابط",
    controlsActive: "من {{total}} نشطة",
    controlsTitle: "الضوابط الأمنية",
    controlsHint: "الضوابط المطبقة في هذا النموذج التجريبي وربطها بمتطلبات طلب العروض.",
    recentLogins: "أحداث المصادقة الأخيرة",
    recentInjections: "أحدث نتائج حقن التعليمات",
    noInjections: "لم ترصد محاولات حقن تعليمات في مستندات الحالات."
  },
  analysisPolicy: {
    tab: "سياسة التحليل",
    hint: "كل رقم يعتمد عليه التقييم الهيكلي – منهجية الاحتساب: الحدود القانونية، ونطاقات قراءة مؤشر هيرفندال، وأوزان درجة المخاطر القابلة للتفسير، وحدود قراءة الثقة، وسيناريوهات المعالجة المتاحة للموظفين، ودورية متابعة التعهدات. وكل تغيير إصدار جديد من المنهجية: يدرج عند الحفظ في إصدارك قيد الإعداد، ولا يصل إلى الأدوات الحسابية وحقائق الوكلاء وشاشات الموظفين إلا بعد أن يعتمد مسؤول ثان الإصدار. وتحتفظ الأرقام والتقارير والقرارات بالإصدار الذي حسبت به.",
    readOnly: "للاطلاع فقط — التعديل لمسؤولي المنصة",
    saved: "أدرج في الإصدار «{{title}}» بوصفه منهجية الاحتساب {{version}}",
    reset: "أدرجت القيم الافتراضية للمنصة في الإصدار «{{title}}» بوصفها منهجية الاحتساب {{version}}",
    stage: "الإدراج في إصدار",
    stageDefaults: "إدراج القيم الافتراضية",
    method: "منهجية الاحتساب {{version}}",
    methodApproved: "معتمدة من {{name}}",
    methodProposed: "مقترحة – بانتظار اعتماد الإدارة",
    pending: "منهجية الاحتساب {{version}} بانتظار الإصدار «{{title}}» ({{status}}). ولا تسري إلا بعد أن يعتمد مسؤول ثان الإصدار؛ وإلى ذلك الحين تسري المنهجية {{current}}.",
    openRelease: "فتح الإصدار",
    confidence: "حدود الثقة",
    confidenceHint: "الحدود التي تقرأ بها كل نسبة ثقة – قراءة المنصة لمعيار المراجعة ومسودة الوكيل – وتنشر مع المنهجية.",
    confidenceHigh: "مرتفعة (خضراء) ابتداء من (%)",
    confidenceMedium: "متوسطة (كهرمانية) ابتداء من (%)",
    restoreDefaults: "استعادة الافتراضي",
    statutory: "الحدود القانونية",
    statutoryHint: "قرار مجلس الوزراء رقم (3) لسنة 2025 — حدود الإخطار في المادة 3 ونسبة الوضع المسيطر في المادة 2.",
    turnoverThreshold: "حد إجمالي المبيعات في الدولة (درهم)",
    shareThreshold: "حد الحصة السوقية ونسبة الوضع المسيطر (%)",
    crN: "نسبة التركز (CR-n)",
    crNHint: "عدد المنشآت الرائدة التي تجمع حصصها، وعادة 4.",
    divestiturePresets: "سيناريوهات التنازل (%)",
    divestitureHint: "تعرض كاختبارات افتراضية بنقرة واحدة في تبويب تحليل الحالة.",
    bands: "نطاقات التركز",
    bandsHint: "كيفية قراءة مؤشر هيرفندال وتغيره عند تصنيف السوق.",
    hhiModerate: "مركز بدرجة متوسطة اعتبارا من (HHI)",
    hhiHigh: "مركز بدرجة عالية اعتبارا من (HHI)",
    deltaSignificant: "تغير HHI المثير للقلق — تركز متوسط",
    deltaMinor: "تغير HHI المثير للقلق — تركز عال",
    deltaPresumption: "تغير HHI الذي ينبه إلى مخاوف محتملة على المنافسة (مؤشر فرز وليس قرينة قانونية)",
    riskWeights: "أوزان درجة الفرز البنيوية",
    riskWeightsHint: "الدرجة البنيوية القابلة للتفسير من 0 إلى 100 المستخدمة لترتيب أولويات الفحص (الفرز والغربلة). ولا تحدد التوصية أبدا.",
    shareBands: "نقاط الحصة المجمعة",
    deltaBands: "نقاط تغير HHI",
    bandSyntax: "الصيغة: الحد:النقاط، من الأعلى إلى الأدنى — مثال 60:30، 40:24، 30:14.",
    pointsHigh: "نقاط — تركز عال",
    pointsModerate: "نقاط — تركز متوسط",
    pointsVertical: "نقاط — تداخل رأسي أو تكتلي",
    pointsSensitive: "نقاط — قطاع حساس",
    pointsPerConcern: "نقاط لكل ملاحظة من طرف ذي مصلحة",
    pointsPerObjection: "نقاط لكل اعتراض مقبول شكلا",
    monitoring: "المتابعة بعد القرار",
    monitoringHint: "القيم الافتراضية عند إنشاء سجل التعهدات من القرار.",
    reviewInterval: "دورية المراجعة (أيام)",
    reminderLead: "مهلة التذكير المسبق (أيام)",
    throughRelease: "لا يسري التغيير إلا عبر إصدار يعتمده مسؤول ثان، بوصفه إصدارا جديدا من منهجية الاحتساب؛ وتحتفظ المسودات والتقارير والقرارات بالإصدار الذي أعدت به.",
    exPost: "التقييم اللاحق",
    exPostHint: "متى يعاد قراءة القرار المغلق مقابل بنك البيانات، وإلى أي حد يجوز أن تنحرف البنية والأسعار الملاحظة عن توقعات التقرير قبل أن يحسب القرار إخفاقا.",
    exPostMonths: "الأشهر بعد الإغلاق",
    exPostHhiTolerance: "سماحية HHI (نقاط)",
    exPostPriceTolerance: "سماحية السعر (نقاط مئوية)",
    lessons: "دروس التقييمات اللاحقة",
    lessonsHint: "ما سجلته التقييمات المكتملة لهذه السياسة – اقرأها قبل تعديل هامش أو نسبة استعادة أو افتراض دخول.",
    noLessons: "لا تقييمات مكتملة بعد",
    noLessonsHint: "تظهر الدروس هنا بعد تسجيل تقييم لاحق على حالة مغلقة.",
    evaluations: "التقييمات المجدولة",
    evaluationsHint: "كل قرار تعهدت الإدارة بتقييمه، المستحق أولا.",
    noEvaluations: "لا تقييمات مجدولة."
  },
  integrations: {
    title: "مراقبة التكاملات",
    subtitle: "الحالة وزمن الاستجابة والتدقيق لكل تكامل مع الأنظمة الحكومية.",
    endpoint: "نقطة الاتصال",
    health: "الحالة",
    latency: "زمن الاستجابة (p95)",
    calls: "الطلبات (24 ساعة)",
    errors: "الأخطاء",
    breaker: "قواطع الدائرة",
    simulateFailure: "محاكاة انقطاع",
    restore: "استعادة",
    systems: "الأنظمة",
    healthyOf: "السليمة: {{count}}",
    last24h: "آخر 24 ساعة",
    errorRate: "نسبة أخطاء {{rate}}%",
    worstP95: "أبطأ نظام p95",
    breakersOpen: "مفتوحة",
    systemsDown: "الأنظمة المتوقفة: {{count}}",
    allHealthy: "كل الأنظمة سليمة",
    traffic: "الحركة وزمن الاستجابة",
    trafficHint: "الطلبات لكل نظام والإخفاقات وزمن p95 عبر الوقت.",
    healths: {
      Unknown: "غير معروف",
      Healthy: "سليم",
      Degraded: "متدهور",
      Down: "متوقف"
    },
    circuitOpen: "الدائرة مفتوحة",
    noCalls: "لا طلبات بعد",
    consecutiveFailures: "الإخفاقات المتتالية: {{count}} – تفتح الدائرة عند 5",
    probe: "فحص",
    probeResult: "{{key}}: {{outcome}} خلال {{ms}} مللي ثانية",
    openBreaker: "فتح القاطع",
    closeBreaker: "إغلاق القاطع",
    breakerOpened: "{{key}}: فتحت الدائرة – ترفض الطلبات",
    breakerClosed: "{{key}}: أغلقت الدائرة",
    manualReason: "فتحت يدويا من مراقبة التكاملات",
    outage: "انقطاع",
    outageOn: "{{key}}: المحاكي يعيد الآن 503",
    outageOff: "{{key}}: تمت استعادة المحاكي",
    latencyMs: "زمن مضاف (مللي ثانية)",
    successRate: "نسبة النجاح",
    failedOnly: "الفاشلة فقط",
    operation: "العملية",
    trace: "التتبع"
  },
  redraft: {
    button: "إعادة الصياغة بالذكاء الاصطناعي",
    title: "إعادة الصياغة بالذكاء الاصطناعي",
    hint: "اذكر ما يجب تغييره. يعيد المساعد كتابة النص ويعرضه بجانب النص الحالي — تحفظ الوقائع والأرقام والاستشهادات، ولا يحفظ شيء قبل أن تطبقه.",
    instruction: "ما الذي يجب تغييره؟",
    instructionPlaceholder: "مثلا: أقصر وأكثر رسمية؛ ذكر أن إيصال البنك لرسم التقديم ما زال ناقصا؛ وضع النواقص أولا…",
    suggestions: {
      formal: "أكثر رسمية",
      shorter: "أقصر",
      clearer: "أوضح وأحسن تنظيما",
      grammar: "تصحيح النحو والأخطاء المطبعية",
      translateAr: "ترجمة إلى العربية",
      translateEn: "ترجمة إلى الإنجليزية",
      fromContext: "اكتبه لي من المعيار وحكمي وما وجدته المنصة"
    },
    run: "أعد الصياغة",
    rerun: "حاول مجددا",
    apply: "تطبيق الصياغة",
    applied: "طبقت الصياغة — راجعها ثم سجل أو اعتمد كالمعتاد",
    current: "النص الحالي",
    proposed: "الصياغة المقترحة",
    waiting: "تظهر الصياغة هنا.",
    empty: "النص فارغ — سيكتبه المساعد من تعليماتك والسياق.",
    showChanges: "إظهار التغييرات",
    hideChanges: "إخفاء التغييرات",
    unchanged: "أعاد المساعد النص دون تغيير. قد تفيد تعليمات أكثر تحديدا.",
    offline: "إعادة الصياغة بالذكاء الاصطناعي غير متاحة ما دامت المنصة تعمل دون نموذج لغوي؛ حرر النص يدويا.",
    flags: "رصدت تعليمات مخفية داخل النص وتم تجاهلها؛ اقرأ النتيجة بعناية.",
    failed: "فشلت إعادة الصياغة",
    meter: "{{model}} · {{ms}} م.ث"
  },
  inbox: {
    proposedAction: "الإجراء المقترح",
    reviseHint: "أخبر الوكيل بما يجب تغييره. ترفض المسودة الحالية مع ملاحظتك ويعيد الوكيل الصياغة فورا؛ وتستخدم الملاحظة أيضا في التشغيلات اللاحقة.",
    aiDraft: "مسودة الوكيل",
    yourVersion: "نسختك — ما سيعتمد",
    editHintChanged: "ستسجل تعديلاتك كتغذية راجعة لتقييم الوكيل.",
    editHintNoChanges: "لا توجد تغييرات بعد.",
    resetToDraft: "تجاهل تعديلاتك والبدء من جديد من مسودة الوكيل",
    reviewNote: "ملاحظة المراجعة (اختياري)",
    approveAndExecute: "اعتماد وتنفيذ",
    reviewNoteRequired: "ملاحظة المراجعة",
    reviseNoteHint: "كن محددا: أي قسم، أي مادة، أي رقم. يعرض الوكيل ملاحظتك في سجل نشاطه.",
    rejectNoteHint: "لماذا هذا المقترح غير مقبول؟ تغذى ملاحظات الرفض إلى الوكيل في تشغيلاته التالية."
  },
  workspace: {
    exPost: {
      tab: "التقييم اللاحق",
      title: "التقييم اللاحق للقرار",
      hint: "ما توقعه التقرير لكل سوق – البنية والأسعار والدخول – وما كان على الالتزامات تحقيقه، مقروءا مقابل بنك البيانات بعد القرار. أكمله بحكم ونتائج ودروس تأخذها سياسة التحليل.",
      none: "لا تقييم لاحق مجدول",
      noneHint: "يجدول التقييم عند إغلاق الحالة المقررة.",
      status: {
        Scheduled: "مجدول",
        Read: "مقروء",
        Completed: "مكتمل"
      },
      verdicts: {
        AsPredicted: "كما هو متوقع",
        BetterThanPredicted: "أفضل من المتوقع",
        WorseThanPredicted: "أسوأ من المتوقع",
        Inconclusive: "غير حاسم",
        NoData: "لا بيانات"
      },
      entryReadings: {
        Likely: "محتمل",
        Unlikely: "غير محتمل",
        NotAssessed: "غير مقيم"
      },
      read: "قراءة بنك البيانات",
      reread: "إعادة قراءة بنك البيانات",
      readDone: "قرئ بنك البيانات مقابل توقعات التقرير.",
      complete: "تسجيل التقييم",
      completed: "سجل التقييم ودروسه على صفحة سياسة التحليل.",
      record: "تسجيل",
      decision: "القرار",
      dueAt: "الاستحقاق",
      inDays: "الأيام المتبقية: {{count}}",
      overdueDays: "أيام التأخير: {{count}}",
      lastRead: "آخر قراءة",
      efficiencies: "مكاسب الكفاءة المدعاة",
      cognisable: "معتبرة",
      suggested: "الحكم المقترح",
      notRead: "لم يقرأ بنك البيانات لهذا القرار بعد. اقرأه لمقارنة ما فعلته السوق بما توقعه التقرير.",
      hhiPredicted: "HHI متوقع",
      hhiObserved: "HHI ملاحظ",
      sharePredicted: "حصة المندمجة المتوقعة",
      shareObserved: "حصة المندمجة الملاحظة",
      pricePredicted: "أثر السعر المحاكى",
      priceObserved: "تغير السعر الملاحظ",
      entry: "الدخول",
      verdict: "الحكم",
      commitments: "الالتزامات",
      suggestedLessons: "دروس مقترحة لسياسة التحليل",
      findings: "النتائج",
      findingsHint: "ما فعلته السوق مقابل ما توقعه التقرير، سوقا بسوق، وهل صمدت الالتزامات.",
      policyLessons: "دروس لسياسة التحليل",
      policyLessonsHint: "ما ينبغي أن تأخذه افتراضات الهامش والاستعادة والدخول والتدابير من هذه الحالة – أو أن لا شيء يحتاج إلى تغيير، ولماذا.",
      completedBy: "أكمله {{name}} · {{date}}"
    }
  }
} as const;
